import { PrismicImage, PrismicLink } from "@prismicio/react";
import { PrismicRichText } from "@prismicio/react";
import { useRef } from "react";

/**
 * @typedef {import("@prismicio/client").Content.FourHundredFourSlice} FourHundredFourSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FourHundredFourSlice>} FourHundredFourProps
 * @param {FourHundredFourProps}
 */


const FullProjectItem = ({ project, isSquare, label, index }) => {
  const ref = useRef()

  function setRounded() {
    if (Array.from(ref.current.classList).join(' ').includes('rounded')) return;
    if (ref.current.clientWidth + 30 < ref.current.clientHeight) {
      Math.random() > .5 ? ref.current.classList.add('rounded-t') : ref.current.classList.add('rounded-bl'); // Randomly add rounded corners
    } else {
      ref.current.classList.add('rounded-tl');
    }
  }
  return <div className="mb-10 md:mb-0 lg:mb-[70px] w-full hidden lg:block ">
    <div ref={ref}className={`mb-5 relative ${isSquare ? 'aspect-square' : 'md:w-full lg:h-[540px]'} carousel-container-parent overflow-hidden`}>
      <PrismicImage field={project.data.preview_picture} className="object-cover aspect-square lg:aspect-auto w-full md:h-full block absolute"  loading={index === 0 ? '' : 'lazy'}/>
      <PrismicLink field={project} onMouseEnter={setRounded}>
        <div className="opacity-0 hover:opacity-100 bg-pink/40 transtion-all duration-500 h-full w-full relative flex justify-center items-center">
          <div className="button button-rounded button-text overflow-hidden background-slide-white">
            {label}
          </div>
        </div>
      </PrismicLink>
    </div>
    <div className="flex flex-row-reverse">
      <div className="flex justify-end w-1/3 mt-1">
        <div className={`tag-rea w-fit h-fit bg-${project.data.preview_tag} py-1.5 px-2.5 border-0 rounded-[22px]`}>
          <h2>{project.data.preview_tag}</h2>
        </div>
      </div>
      <div className="text-info w-2/3">
        <PrismicRichText field={project.data.preview_name}
          components={{
            heading2: ({ children }) => <h2 className="h3">{children}</h2>
          }}
        />
      </div>
    </div>
  </div>
}

export default FullProjectItem